import { render, staticRenderFns } from "./categoryMarket.vue?vue&type=template&id=14a0c8fc&scoped=true"
import script from "./categoryMarket.vue?vue&type=script&lang=js"
export * from "./categoryMarket.vue?vue&type=script&lang=js"
import style0 from "./categoryMarket.vue?vue&type=style&index=0&id=14a0c8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a0c8fc",
  null
  
)

export default component.exports